const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.55,
    height: 24.86,
    viewBox: "0 0 57.55 24.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.36,9.98l4.47-.1-.73-7.17-4.67,.1h0c-.74,0-.77,.75-.77,.82l.04,5.7c0,.76,1.66,.65,1.66,.65Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.64 10.22 42.53 11.36 45.37 11.54 45.98 11.13 46.02 7.41 41.39 2.77 40.44 2.78 41.23 10.02 41.64 10.22",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.78,11.98l-.04,4.4,.34-.14h.07s-.03-3.79-.03-3.79c-.07-.41-.34-.47-.34-.47Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,13.85L1.8,13.19l-.06,1.08,53.26,.45c-.07-.61-.82-.87-.82-.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.43,11.83c2.65,1.61,2.06,4.18,2.06,4.18h0c.54,.06,1.15,.2,1.15,.2-.14-.81-.49-2.5-.49-2.5-.35-1.42-2.72-1.88-2.72-1.88Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09,16.34c-2.37,.02-4.25,1.92-4.24,4.29s1.92,4.25,4.29,4.24,4.25-1.92,4.24-4.29-1.92-4.25-4.29-4.24Z",
    style: {
      fill: "#c1966f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,16.2c-2.37,.02-4.25,1.92-4.24,4.29s1.92,4.25,4.29,4.24,4.25-1.92,4.24-4.29c-.02-2.37-1.92-4.25-4.29-4.24Z",
    style: {
      fill: "#c1966f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.42,13.43h0c-.62-1.42-4.97-3.82-4.97-3.82-.95-.26-2.17-.59-2.17-.59l.06-.74-1.08-.13-5.65-5.44c-1.02-.87-3.03-2.51-3.03-2.51C35.71-.13,2.34,.05,2.34,.05l-.82,2.04C.34,7.38,.47,16.38,.47,16.38l-.47,.95,.02,2.37c-.06,.88,.34,.88,.34,.88l2.1,.19,.21,.47,2.98-.16c-.06,1.08,.69,1.21,.69,1.21-.72-6.56,4.29-6.66,4.29-6.66,5.41-.71,5.38,5.31,5.38,5.31l26.8,.5c-.19,1.22,.49,1.69,.49,1.69l.06-1.83c-.17-4.87,4.56-5.78,4.56-5.78,5.41-.1,5.32,5.72,5.32,5.72l3.45-.23c.2-.68,.4-1.09,.4-1.09,.13-.81,.46-1.49,.46-1.49,.18-2.91-1.12-5-1.12-5ZM1.14,16.24h-.07s-.34,.14-.34,.14l.04-4.4s.27,.07,.34,.47l.03,3.79ZM41.39,2.77l4.63,4.64-.04,3.72-.61,.41-2.84-.18-.89-1.14-.41-.2-.79-7.24h.95Zm-6.73,.86c0-.07,.03-.82,.77-.82h0s4.67-.1,4.67-.1l.73,7.17-4.47,.1s-1.66,.11-1.66-.65l-.04-5.7Zm-32.25-.02c0-.66,.54-1.18,1.2-1.18l29.16,.32c.66,0,1.18,.54,1.18,1.2l-.05,4.84c0,.66-.54,1.18-1.2,1.18l-29.16-.32c-.66,0-1.18-.54-1.18-1.2l.05-4.84Zm-.67,10.66l.06-1.08,52.39,.66s.75,.27,.82,.87L1.74,14.28Zm53.75,1.74h0s.59-2.58-2.06-4.18c0,0,2.37,.46,2.72,1.88,0,0,.35,1.69,.49,2.5,0,0-.61-.13-1.15-.2Z",
    style: {
      fill: "#161513"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.bb7462a73eb17a843020d2d3dbb32fba.svg";
export { ForwardRef as ReactComponent };